import { getTextAlign as getGlobalTextAlign } from './global';
export function getTextAlign(transformer) {
    const globalTextAlign = getGlobalTextAlign(transformer);
    return Object.freeze({
        choiceButtonsHalf: { value: globalTextAlign.center },
        form: {
            characterInput: { value: globalTextAlign.center },
            balanceSheet: { value: globalTextAlign.right },
        },
        heading: {
            default: { value: globalTextAlign.left },
            centered: { value: globalTextAlign.center },
        },
        paragraph: {
            default: { value: globalTextAlign.left },
            centered: { value: globalTextAlign.center },
        },
    });
}
